// Фильтры на странице заказов к договорам
import { errorToast } from 'components';

// Zustand store
import { useShallow } from 'zustand/react/shallow';
import { useContractOrdersStore, useOutstaffDashboardStore } from 'storeZustand';

const useContractOrdersFilters = () => {
	// Заказы к договорам
	const [
		orderFilters,
		getContractOrdersParams,
	] = useContractOrdersStore(useShallow((state) => [
		state.orderFilters,
		state.getContractOrdersParams,
	]));

	// Дашборд
	const [
		getOutstaffDashboard,
	] = useOutstaffDashboardStore(useShallow((state) => [
		state.getOutstaffDashboard,
	]))

	// Применить фильтры
	const applyFilters = async () => {
		const fetchData = async () => {
			try {
				await getContractOrdersParams(orderFilters);
				await getOutstaffDashboard(orderFilters);
			} catch (error) {
				errorToast('Произошла ошибка при загрузке заказов.');
			}
		}

		fetchData();
	}

	return { applyFilters };
};

export default useContractOrdersFilters;